"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiantsCrushAbilityHandler = exports.GiantsCrushActorAbilityFactory = exports.GiantsCrushAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const Random_1 = require("../../utils/Random");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class GiantsCrushAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.GiantsCrush;
        this.__typeName = "GiantsCrush";
    }
}
exports.GiantsCrushAbilityArgs = GiantsCrushAbilityArgs;
let GiantsCrushActorAbilityFactory = class GiantsCrushActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("GiantsCrush", "OneEnemies", 0);
    }
};
GiantsCrushActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("GiantsCrush")
], GiantsCrushActorAbilityFactory);
exports.GiantsCrushActorAbilityFactory = GiantsCrushActorAbilityFactory;
let GiantsCrushAbilityHandler = class GiantsCrushAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invokerLevel = container.getLevel(ability.invokerId);
        const [selectedEnemey] = ability.args.target.actorIds;
        container.applyAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "melee",
            attackerId: ability.invokerId,
            targetId: selectedEnemey,
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 45)
            ],
            onHit(sequence) {
                if ((0, Random_1.randomPercent)() <= 50) {
                    container.applyDebuff({
                        sequence,
                        attackerId: ability.invokerId,
                        targetId: selectedEnemey,
                        duration: Duration_1.Duration.Turns(3),
                        effect: new core_1.BleedingEffectArgs("Power", 10)
                    });
                }
            }
        });
    }
};
GiantsCrushAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.GiantsCrush)
], GiantsCrushAbilityHandler);
exports.GiantsCrushAbilityHandler = GiantsCrushAbilityHandler;
